import { Typography } from '@hulu/react-style-components';
import styled from 'styled-components';

export const Label = styled(Typography)<{ $autoCapitalize: boolean }>`
  text-transform: ${({ $autoCapitalize }): string => ($autoCapitalize ? 'uppercase' : 'none')};
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[2]};
`;
